export default __webpack_public_path__ + "static/media/small-task.324e8be0.svg";